import React, { useEffect, useState, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import DivLayout from 'components/sales/divLayout/divLayout';
import CardSection from 'components/sales/cardSection/cardSection';
import DocumentView from 'components/sales/downloadDocView/documentView';

const ApprovedSalesChallan = ({
  history,
  match,
  getChallansForSite,
  siteChallans
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [mrfData, setMrfData] = useState(null);

  useEffect(() => {
    if (getChallansForSite !== null && match.params.site_id !== undefined) {
      (async () => {
        setIsLoading(true);
        await getChallansForSite(match.params.site_id);
        setIsLoading(false);
      })();
    }
  }, [getChallansForSite,match.params.site_id]);

  useEffect(() => {
    if(siteChallans !== undefined && siteChallans !== null) {
       setMrfData(siteChallans);
    }
  },[siteChallans]);
  console.log('mrfData : ' + JSON.stringify(mrfData?.material_mrf_details));
  return (
    <Layout
      title={localization.challanTitle}
      Buttons={``}
      isLoading={isLoading}
      isGoback
    >
    <div className="container-fluid">
    <CardSection title={localization.iMRFDetails} panelN={`panel_Z`}>
    {(mrfData?.material_mrf_details !== undefined && mrfData?.material_mrf_details !== null && mrfData?.material_mrf_details !== "") && 
        <>
        {mrfData?.material_mrf_details.map((data,i) => {
           return (
            <>
            <CardSection title={`Shipment ` + (i+1)} panelN={`panel_Z`}>
            <div className="details-listing">
              <DivLayout
                  heading={localization.mrfNumber}
                  data={data?.mrf_id}
              />
              <DivLayout
                  heading={localization.challanNo}
                  data={data?.id}
              />
              <DivLayout
                  heading={localization.salesOrderNumber}
                  data={data?.transfer_shipment_no}
              />
              <DivLayout
                  heading={localization.orderType}
                  data={data?.order_type}
              />
              <DivLayout
                  heading={localization.invoiceNo}
                  data={data?.invoice_number}
              />
              <DivLayout
                  heading={localization.shipmentDateTime}
                  data={data?.created_at}
              />
              {data?.invoice_link !== '' && data?.invoice_link !== null &&
                <DocumentView attachment={data?.invoice_link} />
              }    
            </div>
            {data?.challan_line_items && data?.challan_line_items?.length > 0 &&
              <>
              <table className="panel-table table table-bordered">
              <thead>
                  <tr>
                      {/* <th>S.No</th>  */}
                      <th>Challan No</th> 
                      <th>Material Code</th> 
                      <th>Material Name</th> 
                      <th>HSN Code</th>
                      <th>Quantity</th>
                      <th>Serial No</th> 
                      <th>Received Serial No</th>  
                      <th>Received Qty</th> 
                      <th>Price</th> 
                      <th>Price (Including GST)</th>
                      <th>Received On</th> 
                      <th>Received By</th>
                  </tr>
              </thead>
              <tbody>
              {data?.challan_line_items?.map((item,i2) => {
                return (
                <tr key={`line_item_${i2}`}>
                  {/* <td>{index + 1}</td> */}
                  <td>{item?.challan_id}</td>
                  <td>{item?.material_code}</td>
                  <td>{item?.name}</td>
                  <td>{item?.hsn}</td>
                  <td>{item?.quantity}</td>
                  <td>{item?.serial_number}</td>
                  <td>{item?.receive_serial_no}</td>
                  <td>{item?.receive_quantity}</td>
                  <td>{item?.rate}</td>
                  <td>{item?.total}</td>
                  {(item?.updated_by_user && item?.receive_serial_no !== null && item?.receive_quantity !== null) ?
                    <td>{item?.updated_at}</td>
                  : <td>NA</td>}
                  {(item?.updated_by_user && item?.receive_serial_no !== null && item?.receive_quantity !== null) ?
                    <td>{item?.updated_by_user?.name}</td>
                  : <td>NA</td>}
                </tr>
                )
              })
              }
              </tbody>
              </table>
              </>
            }
            </CardSection> 
            </>
         )
        })} 
        </>
      }
      </CardSection>
      <CardSection title={localization.mrfTagDetails} panelN={`panel_Z`}>
      {(mrfData?.tag_mrf_details !== undefined && mrfData?.tag_mrf_details !== null) && 
        <>
        {mrfData?.tag_mrf_details?.length > 0 && mrfData?.tag_mrf_details.map((data2,j) => {
           return (
            <>
            <CardSection title={`Shipment ` + (j+1)} panelN={`panel_Z`}>
            <div className="details-listing">
            <DivLayout
                heading={localization.mrfNumber}
                data={data2?.mrf_id}
            />
            <DivLayout
                heading={localization.challanNo}
                data={data2?.id}
            />
            <DivLayout
                heading={localization.salesOrderNumber}
                data={data2?.transfer_shipment_no}
            />
            <DivLayout
                heading={localization.orderType}
                data={data2?.order_type}
            />
            <DivLayout
                heading={localization.invoiceNo}
                data={data2?.invoice_number}
            />
            <DivLayout
                heading={localization.shipmentDateTime}
                data={data2?.created_at}
            />
            {data2?.invoice_link !== '' && data2?.invoice_link !== null &&
              <DocumentView attachment={data2?.invoice_link} />
            }    
        </div>
        {data2?.challan_line_items && data2?.challan_line_items?.length > 0 &&
          <>
          <table className="panel-table table table-bordered">
          <thead>
              <tr>
                  {/* <th>S.No</th>  */}
                  <th>Challan No</th> 
                  <th>Material Code</th> 
                  <th>Material Name</th> 
                  <th>HSN Code</th>
                  <th>Quantity</th>
                  <th>Serial No</th> 
                  <th>Received Serial No</th>  
                  <th>Received Qty</th> 
                  <th>Price</th> 
                  <th>Price (Including GST)</th>
                  <th>Received On</th> 
                  <th>Received By</th>
              </tr>
          </thead>
          <tbody>
          {data2?.challan_line_items?.map((item2,j2) => {
            return (
              <tr key={`line_item_${j2}`}>
                {/* <td>{index + 1}</td> */}
                <td>{item2?.challan_id}</td>
                <td>{item2?.material_code}</td>
                <td>{item2?.name}</td>
                <td>{item2?.hsn}</td>
                <td>{item2?.quantity}</td>
                <td>{item2?.serial_number}</td>
                <td>{item2?.receive_serial_no}</td>
                <td>{item2?.receive_quantity}</td>
                <td>{item2?.rate}</td>
                <td>{item2?.total}</td>
                {(item2?.updated_by_user && item2?.receive_serial_no !== null && item2?.receive_quantity !== null) ?
                 <td>{item2?.updated_at}</td>
                : <td>NA</td>}
                {(item2?.updated_by_user && item2?.receive_serial_no !== null && item2?.receive_quantity !== null) ?
                 <td>{item2?.updated_by_user?.name}</td>
                : <td>NA</td>}
              </tr>
              )
          })
          }
          </tbody>
          </table>
          </>
        }
        </CardSection> 
        </>
         )
        })} 
        </>
      }
      </CardSection>
    </div>
    </Layout>
  );
};

export default ApprovedSalesChallan;
